<form #cardHomingForm="ngForm">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">

      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title">{{ labels.title | translate }}</h1>
      </div>

      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/card-homing" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" type="button" icon="fa fa-floppy-o" iconPos="left" label="Save" [disabled]="!cardHomingForm.valid" (click)="operationType == '2' ? confirm() : cardHoming()"></button>
      </div>

    </div>

    <div class="card">

      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-6 ui-xl-4">
          <span class="label">{{ labels.store_from | translate }}</span>
          <p-autoComplete 
          [(ngModel)]="storeFrom" 
          name="storeFrom" 
          [suggestions]="allStores" 
          (completeMethod)="searchAllStores($event)"
          field="label"
          emptyMessage="{{( labels.empty_message | translate )}}"
          placeholder="{{( labels.search_store | translate )}}"
          required="true">
          </p-autoComplete>
        </div>

        <div class="ui-g-12 ui-md-6 ui-xl-4">
          <span class="label">{{ labels.store_to | translate }}</span>
          <p-autoComplete 
          [(ngModel)]="storeTo" 
          name="storeTo" 
          [suggestions]="sameLoyaltyStores" 
          (completeMethod)="searchLoyaltyStores($event)"
          field="label"
          emptyMessage="{{( labels.empty_message | translate )}}"
          placeholder="{{( labels.search_store | translate )}}"
          required="true">
          </p-autoComplete>
        </div>

        <div class="ui-g-12 ui-xl-4"></div>

      </div>

      <div *ngIf="operationType == '2'" class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-6 ui-xl-4">
          <span class="label">{{ labels.card_no_start | translate }}</span>
          <input 
          pInputText 
          type="text" 
          [(ngModel)]="startingCardNumber" 
          name="startingCardNumber" 
          (keydown)="validateNumber($event)" 
          minlength="12"
          maxlength="13"
          required>
        </div>

        <div class="ui-g-12 ui-md-6 ui-xl-4">
          <span class="label">{{ labels.card_no_end | translate }}</span>
          <input 
          pInputText 
          type="text" 
          [(ngModel)]="endingCardNumber" 
          name="endingCardNumber" 
          (keydown)="validateNumber($event)" 
          minlength="12"
          maxlength="13"
          required>
        </div>

        <div class="ui-g-12 ui-xl-4"></div>

      </div>

    </div>

  </div>
</form>
<p-confirmDialog key="confirm"></p-confirmDialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-homing/loyalty-card-homing-form/loyalty-card-homing-form.component.html